import { IAction } from "../../../interface/action.interface";
import { ListColumns } from "../enum/list-columns";
import { IFetchListsResponseDto } from "../interface/dto/lists.dto";
import { ISelectedFilters } from "../interface/selected-filters";

export enum DataBrowserListActionTypes {
    DATABROWSER_LIST_INIT = "DATABROWSER_LIST_INIT",
    DATABROWSER_LIST_SET_FILTERS = "DATABROWSER_LIST_SET_FILTERS",
    DATABROWSER_LIST_RESET_FILTERS = "DATABROWSER_LIST_RESET_FILTERS",
    DATABROWSER_LIST_SET_COLUMNS = "DATABROWSER_LIST_SET_COLUMNS",
    DATABROWSER_LIST_LOAD_LISTS = "DATABROWSER_LIST_LOAD_LISTS",
    DATABROWSER_LIST_LOAD_LISTS_SUCCESS = "DATABROWSER_LIST_LOAD_LISTS_SUCCESS",
    DATABROWSER_LIST_LOAD_LISTS_ERROR = "DATABROWSER_LIST_LOAD_LISTS_ERROR",
    DATABROWSER_LIST_SET_PAGINATION = "DATABROWSER_LIST_SET_PAGINATION",
    DATABROWSER_LIST_SET_SORTING = "DATABROWSER_LIST_SET_SORTING",
    DATABROWSER_SELECT_ALL_TOGGLE = "DATABROWSER_SELECT_ALL_TOGGLE",
    DATABROWSER_SELECT_LIST_TOGGLE = "DATABROWSER_SELECT_LIST_TOGGLE",
    DATABROWSER_EXPORT_CATALOG = "DATABROWSER_EXPORT_CATALOG",
}

export interface IInitDataBrowserListAction extends IAction {
    type: DataBrowserListActionTypes.DATABROWSER_LIST_INIT;
}

export const initDataBrowserListAction = () => ({
    type: DataBrowserListActionTypes.DATABROWSER_LIST_INIT,
});

export interface IDataBrowserListSetFiltersAction extends IAction {
    type: DataBrowserListActionTypes.DATABROWSER_LIST_SET_FILTERS;
    payload: {
        filters: ISelectedFilters;
    };
}

export interface IDataBrowserListResetFiltersAction extends IAction {
    type: DataBrowserListActionTypes.DATABROWSER_LIST_RESET_FILTERS;
}
export interface IDataBrowserListSetColumnsAction extends IAction {
    type: DataBrowserListActionTypes.DATABROWSER_LIST_SET_COLUMNS;
    payload: Array<ListColumns>;
}

export interface IDataBrowserListLoadListsAction extends IAction {
    type: DataBrowserListActionTypes.DATABROWSER_LIST_LOAD_LISTS;
}

export interface IDataBrowserListLoadListsSuccessAction extends IAction {
    type: DataBrowserListActionTypes.DATABROWSER_LIST_LOAD_LISTS_SUCCESS;
    payload: IFetchListsResponseDto;
}

export interface IDataBrowserListLoadListsErrorAction extends IAction {
    type: DataBrowserListActionTypes.DATABROWSER_LIST_LOAD_LISTS_ERROR;
    payload: { error: string };
}

export interface IDataBrowserListSetPaginationAction extends IAction {
    type: DataBrowserListActionTypes.DATABROWSER_LIST_SET_PAGINATION;
    payload: {
        currentPage: number;
        itemsPerPage: number;
    };
}

export interface IDataBrowserListSetSortingAction extends IAction {
    type: DataBrowserListActionTypes.DATABROWSER_LIST_SET_SORTING;
    payload: {
        column: ListColumns;
        order: "asc" | "desc";
    };
}

export interface IDataBrowserExportAction extends IAction {
    type: DataBrowserListActionTypes.DATABROWSER_EXPORT_CATALOG;
}

export interface IDataBrowserSelectAllToggleAction extends IAction {
    type: DataBrowserListActionTypes.DATABROWSER_SELECT_ALL_TOGGLE;
}

export interface IDataBrowserSelectListToggleAction extends IAction {
    type: DataBrowserListActionTypes.DATABROWSER_SELECT_LIST_TOGGLE;
    payload: {
        listId: number;
    };
}

export const dataBrowserListSetFiltersAction = (
    filters: ISelectedFilters,
): IDataBrowserListSetFiltersAction => ({
    type: DataBrowserListActionTypes.DATABROWSER_LIST_SET_FILTERS,
    payload: {
        filters,
    },
});

export const dataBrowserListResetFiltersAction = () => ({
    type: DataBrowserListActionTypes.DATABROWSER_LIST_RESET_FILTERS,
});

export const dataBrowserListSetColumnsAction = (
    columns: Array<ListColumns>,
): IDataBrowserListSetColumnsAction => ({
    type: DataBrowserListActionTypes.DATABROWSER_LIST_SET_COLUMNS,
    payload: columns,
});

export const dataBrowserListLoadListsAction =
    (): IDataBrowserListLoadListsAction => ({
        type: DataBrowserListActionTypes.DATABROWSER_LIST_LOAD_LISTS,
        payload: {},
    });

export const dataBrowserListLoadListsSuccessAction = (
    data: IFetchListsResponseDto,
): IDataBrowserListLoadListsSuccessAction => ({
    type: DataBrowserListActionTypes.DATABROWSER_LIST_LOAD_LISTS_SUCCESS,
    payload: data,
});

export const dataBrowserListLoadListsErrorAction = (
    error: string,
): IDataBrowserListLoadListsErrorAction => ({
    type: DataBrowserListActionTypes.DATABROWSER_LIST_LOAD_LISTS_ERROR,
    payload: { error },
});

export const dataBrowserListSetPaginationAction = (
    currentPage: number,
    itemsPerPage: number,
): IDataBrowserListSetPaginationAction => ({
    type: DataBrowserListActionTypes.DATABROWSER_LIST_SET_PAGINATION,
    payload: { currentPage, itemsPerPage },
});

export const dataBrowserListSetSortingAction = (
    column: ListColumns,
    order: "asc" | "desc",
): IDataBrowserListSetSortingAction => ({
    type: DataBrowserListActionTypes.DATABROWSER_LIST_SET_SORTING,
    payload: { column, order },
});

export const dataBrowserExportCatalogAction = (): IDataBrowserExportAction => ({
    type: DataBrowserListActionTypes.DATABROWSER_EXPORT_CATALOG,
    payload: {},
});

export const dataBrowserSelectAllToggleAction =
    (): IDataBrowserSelectAllToggleAction => ({
        type: DataBrowserListActionTypes.DATABROWSER_SELECT_ALL_TOGGLE,
        payload: {},
    });

export const dataBrowserSelectListToggleAction = (
    listId: number,
): IDataBrowserSelectListToggleAction => ({
    type: DataBrowserListActionTypes.DATABROWSER_SELECT_LIST_TOGGLE,
    payload: {
        listId,
    },
});

export type IDataBrowserListActions =
    | IDataBrowserListSetFiltersAction
    | IDataBrowserListResetFiltersAction
    | IDataBrowserListSetColumnsAction
    | IDataBrowserListLoadListsAction
    | IDataBrowserListLoadListsSuccessAction
    | IDataBrowserListLoadListsErrorAction
    | IDataBrowserListSetPaginationAction
    | IDataBrowserListSetSortingAction
    | IDataBrowserSelectAllToggleAction
    | IDataBrowserSelectListToggleAction
    | IInitDataBrowserListAction
    | IDataBrowserExportAction;
